import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import { CalsoftMockApi } from 'src/app/global/mock-api/mock-api.interfaces';
import { CalsoftNavigationItem } from 'src/app/global/components/navigation';
import { CalsoftMockApiService } from 'src/app/global/mock-api/mock-api.service';
import { compactNavigation, defaultNavigation, futuristicNavigation, horizontalNavigation } from './data';

@Injectable({
    providedIn: 'root'
})
export class NavigationMockApi implements CalsoftMockApi {
    // Private Readonly
    private readonly _compactNavigation: CalsoftNavigationItem[];
    private readonly _defaultNavigation: CalsoftNavigationItem[];
    private readonly _futuristicNavigation: CalsoftNavigationItem[];
    private readonly _horizontalNavigation: CalsoftNavigationItem[];

    /**
     * Constructor
     *
     * @param _calsoftMockApiService
     */
    constructor(
        private _calsoftMockApiService: CalsoftMockApiService
    ) {
        // Set the data
        this._compactNavigation = compactNavigation;
        this._defaultNavigation = defaultNavigation;
        this._futuristicNavigation = futuristicNavigation;
        this._horizontalNavigation = horizontalNavigation;

        // Register the API endpoints
        this.register();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register
     */
    register(): void {
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._calsoftMockApiService
            .onGet('api/common/navigation')
            .reply(() => {

                // Fill compact navigation children using the default navigation
                this._compactNavigation.forEach((compactNavItem) => {


                    compactNavItem.children = _.cloneDeep(compactNavItem.children);


                });

                // Fill compact navigation children using the default navigation
                this._futuristicNavigation.forEach((futuristicNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === futuristicNavItem.id) {
                            futuristicNavItem.children = _.cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill horizontal navigation children using the default navigation
                this._horizontalNavigation.forEach((horizontalNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === horizontalNavItem.id) {
                            horizontalNavItem.children = _.cloneDeep(defaultNavItem.children);
                        }
                    });
                });
                
                
                return [
                    200,
                    {
                        compact: _.cloneDeep(this._compactNavigation),
                        default: _.cloneDeep(this._defaultNavigation),
                        futuristic: _.cloneDeep(this._futuristicNavigation),
                        horizontal: _.cloneDeep(this._horizontalNavigation)
                    }
                ];
            });
    }
}
